// Model.js
// -----------------------
// @module Case
define("Convergence.featuredProd.featuredProd.Collection", 
    [
        "Item.Collection"
    ,   "Utils"
    ,   "Profile.Model"
    ,   "Convergence.featuredProd.featuredProd.Model"
    ,   "Session"
    ,   "SC.Configuration"
    ,   "underscore"
    ,   'Item.Model'
    ], 
    function(
        ItemCollection
    ,   Utils
    ,   ProfileModel
    ,   TopDealsExtModel
    ,   Session
    ,   Configuration
    ,   _
    ,   ItemModel
  
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return ItemCollection.extend({
        customfacetsID: 'custitem_ns_ib_badges',
        pageSize:20,
        url: function () {
            
            
            var profile = ProfileModel.getInstance(),
                sessionSearchApiParams = Session.getSearchApiParams(false);

            

            delete sessionSearchApiParams[this.customfacetsID];
            sessionSearchApiParams.fieldset = "search";
            sessionSearchApiParams.custitem_ns_ib_badges = 'Featured';
            sessionSearchApiParams.limit = '6';
            var url = _.addParamsToUrl(
                profile.getSearchApiUrl(),
                _.extend(
                    (Configuration.get('matrixchilditems.enabled') && Configuration.get('matrixchilditems.fieldset')) ? {
                        matrixchilditems_fieldset: Configuration.get('matrixchilditems.fieldset')
                    } : {},
                    this.searchApiMasterOptions,
                    sessionSearchApiParams
                ),
                profile.isAvoidingDoubleRedirect()
            );

            return url;
        },
        model: ItemModel,
        
                
        parse: function (response) {
            this.totalRecordsFound = response.total;
            
            
            return response.items;
        },
        update: function (options, list_header) {
            var self = this,
            sortOrder

            var dataFilters = {
                fieldset: 'search',
                sort: (options.order > 0 ? ':asc' : ':asc'),
                // sort: sortOrder + (options.order > 0 ? ':asc' : ':desc'), 
                limit: 6,
                offset: this.pageSize * (parseInt(options.page || 1, 10) - 1)
            };
            
                dataFilters[this.customersFacetId] = profile.get('customerFacetValueUrl') || 'XXXXXXXXXXXXXXXX';
            
            this.fetch({
                data: dataFilters,
                reset: true,
                killerId: options.killerId
            });
        }
        
    });
});
